import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getPracticeToothNumberingSystem } from 'utils/autochartUtils'

export const useToothNumberingSystem = () => {
  const practiceDetails = useSelector(state => state.practiceReducer.details)
  const accountOwner = useSelector(state => state.practiceReducer.accountOwner)

  return useMemo(
    () =>
      getPracticeToothNumberingSystem({
        appSettings: accountOwner?.user?.appSettings,
        country: practiceDetails?.country
      }),
    [accountOwner?.user?.appSettings, practiceDetails?.country]
  )
}
